//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

	name: "hub-installations-data-table",

	props: {
		namespace: {required: true, type: String}
	},

	computed: {

		dataSource()
		{
			return `/api/hub/apps/${this.namespace}/data-table/installations`;
		}

	}

}

